import type { ActionsNetwork } from 'shared/store/actions'
import { actionNetworkError } from 'shared/store/actions'
import { ws } from 'shared/store/ws'
import endpoints from 'shared/store/endpoints'
import type { Dispatch } from 'redux'
import { errors } from 'shared/utils'
import type { OperationRepeat } from 'shared/types'
import type { State as HomeState } from 'shared/store/homepage'

const endpointRoot = endpoints.pages.operation.root + '/'

type ActionMysteryBurgerError = {
    type: 'MYSTERY_BURGER_ERROR',
    error: boolean
}

type ActionHomepageOperationRepeat = {
    type: 'PAGE_DATA_HOMEPAGE_RESPONSE',
    data: HomeState
}

type ActionSetOperationRepeat = {
    type: 'MYSTERY_BURGER_SET_OPERATION_REPEAT',
    operationRepeat: OperationRepeat
}

type ActionUpdateLastConfirmModalShown = {
    type: 'MYSTERY_BURGER_UPDATE_LAST_CONFIRM_MODAL_SHOWN'
}

const setMysteryBurgerOperationRepeat = (
    operationRepeat: OperationRepeat
): ActionSetOperationRepeat => ({
    type: 'MYSTERY_BURGER_SET_OPERATION_REPEAT',
    operationRepeat
})

const updateLastMysteryBurgerConfirmModalShown = (): ActionUpdateLastConfirmModalShown => ({
    type: 'MYSTERY_BURGER_UPDATE_LAST_CONFIRM_MODAL_SHOWN'
})

const getWallet = (
    operationCode: string,
    restaurantCode: string,
    king: string
) => {
    return async (dispatch: Dispatch<any>) => {
        try {
            const response = await ws.get(
                endpointRoot + operationCode + '/wallet',
                {
                    params: {
                        king,
                        restaurantCode
                    }
                }
            )
            dispatch(actionError(undefined))
            return response.data && response.data.wallet
        } catch (error) {
            console.error('Error, could not get coupon for wallet')
            manageError(error, dispatch)
            return false
        }
    }
}

const actionError = (error: any): ActionMysteryBurgerError => ({
    type: 'MYSTERY_BURGER_ERROR',
    error
})

const manageError = (error: any, dispatch: Dispatch<any>) => {
    console.error('Error in mystery burger', error)
    switch (error) {
        case errors.NETWORK:
            dispatch(
                actionNetworkError({
                    type: errors.NETWORK
                })
            )
            break
        case errors.TIMEOUT:
            dispatch(
                actionNetworkError({
                    type: errors.TIMEOUT
                })
            )
            break
        default:
            dispatch(actionError(error))
            break
    }
}

export {
    getWallet,
    actionError,
    setMysteryBurgerOperationRepeat,
    updateLastMysteryBurgerConfirmModalShown
}

export type Action =
    | ActionHomepageOperationRepeat
    | ActionMysteryBurgerError
    | ActionsNetwork
    | ActionSetOperationRepeat
    | ActionUpdateLastConfirmModalShown
